import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Typewriter from 'typewriter-effect';
import { motion } from 'framer-motion';
import '../App.css';

function Landing() {
  const { t } = useTranslation();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100 }
    }
  };

  return (
    <section className="landing-bg">
      {/* Animated Background Blobs */}
      <div className="glow-blob blob-1"></div>
      <div className="glow-blob blob-2"></div>

      <Container style={{ zIndex: 1, position: 'relative' }}>
        <Row className="align-items-center">
          <Col lg={8}>
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              <motion.h2
                variants={itemVariants}
                style={{ color: 'var(--accent-secondary)', fontWeight: '600', marginBottom: '1rem' }}
              >
                Hello, I'm
              </motion.h2>

              <motion.h1
                variants={itemVariants}
                style={{
                  fontSize: '5rem',
                  fontWeight: '800',
                  lineHeight: '1.1',
                  marginBottom: '1.5rem',
                  background: 'linear-gradient(to right, #fff, #a1a1aa)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}
              >
                Kevin Qu
              </motion.h1>

              <motion.div
                variants={itemVariants}
                style={{
                  fontSize: '1.8rem',
                  color: 'var(--text-secondary)',
                  maxWidth: '700px',
                  marginBottom: '2.5rem',
                  height: '3rem'
                }}
              >
                <Typewriter
                  options={{
                    strings: [
                      t('undergrad'),
                      t('majored_in_cs'),
                      "IoT Enthusiast",
                      "Full Stack Developer"
                    ],
                    autoStart: true,
                    loop: true,
                    delay: 50,
                    deleteSpeed: 30,
                  }}
                />
              </motion.div>

              <motion.div variants={itemVariants} className="d-flex gap-3">
                <motion.a
                  href="#projects"
                  className="btn btn-glow"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  style={{
                    background: 'var(--accent-primary)',
                    color: 'white',
                    padding: '12px 30px',
                    borderRadius: '50px',
                    fontWeight: '600',
                    border: 'none',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                >
                  {t('projects')}
                </motion.a>

                <motion.a
                  href="#about"
                  className="btn btn-glass"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  style={{
                    background: 'transparent',
                    color: 'white',
                    padding: '12px 30px',
                    borderRadius: '50px',
                    fontWeight: '600',
                    border: '1px solid var(--glass-border)'
                  }}
                >
                  {t('contact')}
                </motion.a>
              </motion.div>
            </motion.div>
          </Col>
        </Row>
      </Container>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0, x: "-50%" }}
        animate={{ opacity: 1, x: "-50%", y: [0, 10, 0] }}
        transition={{ delay: 2, duration: 1.5, repeat: Infinity }}
        style={{
          position: 'absolute',
          bottom: '40px',
          left: '50%',
          color: 'var(--text-secondary)',
          fontSize: '2rem',
          cursor: 'pointer',
          zIndex: 10 // Ensure it's above other elements
        }}
        onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
      >
        <i className="fa-solid fa-chevron-down"></i>
      </motion.div>
    </section>
  );
}

export default Landing;
